import FORMFIELD from '../../../../../../../DOM/form/fieldset/formfieldgroup/formfield/FORMFIELD.js';
import { makeStruct } from '../../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../../enums/ModelData.js';
import { labelModel } from '../../../../../../../DOM/form/label/LABEL.js';
import { fieldModel } from '../../../../../../../DOM/form/fieldset/field/FIELD.js';
import { spanModel } from '../../../../../../../DOM/span/SPAN.js';
import INPUTTIME from '../../../../../../../DOM/form/fieldset/field/input/inputs/INPUTTIME.js';
import { buttongroupModel, buttongroupAttr } from '../../../../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
// Model Structure
export const formInputTimeAttr = makeAttrStruct([
    ['class']
]);
export const formInputTimeData = makeDataStruct([
    ['label', labelModel()],
    ['field', fieldModel()],
    ['message', spanModel()],
    ['buttons', buttongroupModel(buttongroupAttr('form-field-buttons'))]
]);
export const formInputTimeModel = makeStruct([
    ['attributes', formInputTimeAttr],
    ['data', formInputTimeData]
]);
// Simplified Model
export function formInputTime(label, field, message, buttons) {
    return {
        attributes: formInputTimeAttr(),
        data: formInputTimeData(label, field, message, buttons)
    };
}
/** Represents an Input[type=time] for a Form */
export default class FORMINPUTTIME extends FORMFIELD {
    constructor(node, model) {
        super(node, model);
    }
    createField(model) {
        return new INPUTTIME(this, model);
    }
}
